const DEFAULT_API_URL = 'https://efftechwebsite-production.up.railway.app/api';

export const normalizeApiUrl = (value?: string): string => {
  const trimmed = (value || '').trim();
  if (!trimmed) return DEFAULT_API_URL;

  let normalized = trimmed.replace(/\/+$/, '');

  if (!/^https?:\/\//i.test(normalized)) {
    normalized = `https://${normalized}`;
  }

  if (!/\/api(?:\/|$)/.test(normalized)) {
    normalized = `${normalized}/api`;
  }

  return normalized;
};

export const getApiBaseUrl = (): string => normalizeApiUrl(import.meta.env.VITE_API_URL);
